<template>
  <a-drawer width="50%" :label-col="6" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="couponName">
        <span slot="label">
          <a-tooltip>
            {{this.$t('优惠券名称')}}<template slot="title">{{this.$t('优惠券名称')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.couponName" :maxLength="100" :placeholder="$t('请输入')+$t('优惠券名称')" >
          <locale-field-button
            slot="suffix"
            v-model="form.localeFieldMap['couponName']"
            :disabled="!form.couponName"
            input-type="input"
            table-name="activity_coupon"
            table-field="couponName"
            :field-value="form.couponName"
          />
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="couponType">
        <span slot="label">
          <a-tooltip>
            {{this.$t('优惠券类型')}}<template slot="title">{{this.$t('优惠券类型')}}</template>
          </a-tooltip>
        </span>
        <a-radio-group v-model="form.couponType" button-style="solid">
          <a-radio-button v-for="(item, index) in this.customDict.CouponTypeEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item v-if="form.couponType === 1 || form.couponType === 3" prop="amount">
        <span slot="label">
          <a-tooltip>
             {{this.$t('面额')}}<template slot="title">{{this.$t('面额')}}</template>
          </a-tooltip>
        </span>
        <a-input-number v-model="form.amount" :placeholder="$t('请输入')+ $t('面额')" suffix="$" style="width: 100%;" />
      </a-form-model-item>
      <a-form-model-item v-if="form.couponType === 2" prop="discountRate">
        <span slot="label">
          <a-tooltip>
           {{this.$t('折扣')}} <template slot="title">  {{this.$t('折扣')}} </template>
          </a-tooltip>
        </span>
        <a-input-number v-model="form.discountRate" :max="1" :min="0" :step="0.01" :placeholder="$t('请输入')+ $t('折扣')"  style="width: 100%;" />
      </a-form-model-item>
      <a-form-model-item prop="totalIssue">
        <span slot="label">
          <a-tooltip>
            {{this.$t('发放数量')}}<template slot="title">{{this.$t('发放数量')}}</template>
          </a-tooltip>
        </span>
        <a-input-number v-model="form.totalIssue" :placeholder="$t('请输入')+$t('发放数量')" style="width: 100%;" />
      </a-form-model-item>
      <a-form-model-item prop="thresholdAmount">
        <span slot="label">
          <a-tooltip>
            {{this.$t('满多少元可用')}}<template slot="title"> {{this.$t('满多少元可用')}}</template>
          </a-tooltip>
        </span>
        <a-input-number v-model="form.thresholdAmount" :placeholder="$t('请输入')+$t('满多少元可用')" suffix="$" style="width: 100%;" />
      </a-form-model-item>
      <a-form-model-item prop="validStartTime">
        <span slot="label">
          <a-tooltip>
            {{this.$t('有效期开始时间')}}<template slot="title">{{this.$t('有效期开始时间')}}</template>
          </a-tooltip>
        </span>
        <a-date-picker
          style="width: 100%"
          v-model="form.validStartTime"
          format="YYYY-MM-DD HH:mm:ss"
          valueFormat="YYYY-MM-DD HH:mm:ss"
          :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
          allow-clear
        />
      </a-form-model-item>
      <a-form-model-item prop="validEndTime">
        <span slot="label">
          <a-tooltip>
            {{this.$t('有效期结束时间')}}<template slot="title">{{this.$t('有效期结束时间')}}</template>
          </a-tooltip>
        </span>
        <a-date-picker
          style="width: 100%"
          v-model="form.validEndTime"
          format="YYYY-MM-DD HH:mm:ss"
          valueFormat="YYYY-MM-DD HH:mm:ss"
          :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
          allow-clear
        />
      </a-form-model-item>
      <a-form-model-item prop="categoryId">
        <span slot="label">
          <a-tooltip>
             {{this.$t('使用范围')}}<template slot="title">{{this.$t('使用范围')}}</template>
          </a-tooltip>
        </span>
        <a-input v-if="form.couponType === 3" :value="$t('运费')" disabled />
        <a-select v-else v-model="form.categoryId" :placeholder="$t('请选择')" allow-clear>
          <a-select-option v-for="(item, index) in categoryList" :value="item.id" :key="index">
            {{ item.categoryName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item prop="isNewUser">
        <span slot="label">
          <a-tooltip>
            {{this.$t('是否新人券')}}<template slot="title">{{this.$t('是否新人券')}}</template>
          </a-tooltip>
        </span>
        <a-radio-group v-model="form.isNewUser" button-style="solid">
          <a-radio-button v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item v-if="form.couponType !== 2" prop="isPointExchange">
        <span slot="label">
          <a-tooltip>
           {{this.$t('是否可积分兑换')}} <template slot="title">{{this.$t('是否可积分兑换')}} <</template>
          </a-tooltip>
        </span>
        <a-radio-group v-model="form.isPointExchange" button-style="solid">
          <a-radio-button v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item prop="needPoints" v-if="form.couponType !== 2 && form.isPointExchange">
        <span slot="label">
          <a-tooltip>
            {{this.$t('积分')}}<template slot="title">{{this.$t('积分')}}</template>
          </a-tooltip>
        </span>
        <a-input-number v-model="form.needPoints" :placeholder="$t('请输入')+$t('积分')" style="width: 100%;" />
      </a-form-model-item>
      <a-form-model-item prop="status">
        <span slot="label">
          <a-tooltip>
             {{this.$t('状态')}}<template slot="title">{{this.$t('状态')}}</template>
          </a-tooltip>
        </span>
        <a-radio-group v-model="form.status"  button-style="solid">
          <a-radio-button v-for="(item, index) in this.customDict.GoodsOnOffEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>

  </a-drawer>
</template>

<script>
import { getCoupon, addCoupon, updateCoupon } from '@/api/coupon/coupon'
import { mapGetters } from 'vuex'
import CustomDictTag from '@/components/DictCustomTag'
import moment from 'moment'
import LocaleFieldButton from '@/components/locale/LocaleFieldButton'

export default {
  name: 'CreateForm',
  props: {
    categoryList:{
      type: Array,
      require: true
    }
  },
  components: {
    LocaleFieldButton,
    CustomDictTag
  },
  data() {
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,

        couponName: null,

        couponType: null,

        amount: null,

        discountRate: null,

        thresholdAmount: null,

        validStartTime: null,

        validEndTime: null,

        isNewUser: null,

        isPointExchange: null,

        needPoints: null,

        totalIssue: null,

        issuedNum: null,

        receivedNum: null,

        usedNum: null,

        categoryId: null,

        status: 0,

        images: null,
        localeFieldMap:{},
        createTime: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        couponName: [
          { required: true, message: this.$t('优惠券名称') + this.$t('不能为空'), trigger: 'blur' }
        ],
        couponType: [
          { required: true, message: this.$t('优惠券类型') + this.$t('不能为空'), trigger: 'change' }
        ],
        amount: [
          { required: true, message: this.$t('面额') + this.$t('不能为空'), trigger: 'blur' }
        ],
        discountRate: [
          { required: true, message: this.$t('折扣比例') + this.$t('不能为空'), trigger: 'blur' }
        ],
        thresholdAmount: [
          { required: true, message: this.$t('满多少元可用') + this.$t('不能为空'), trigger: 'blur' }
        ],
        validStartTime: [
          { required: true, message: this.$t('有效期开始时间') + this.$t('不能为空'), trigger: 'change' }
        ],
        validEndTime: [
          { required: true, message: this.$t('有效期结束时间') + this.$t('不能为空'), trigger: 'change' }
        ],
        isNewUser: [
          { required: true, message: this.$t('是否新人券：1是 0否') + this.$t('不能为空'), trigger: 'change' }
        ],
        isPointExchange: [
          { required: true, message: this.$t('是否可积分兑换：1是 0否') + this.$t('不能为空'), trigger: 'change' }
        ],
        needPoints: [
          { required: true, message: this.$t('兑换所需积分') + this.$t('不能为空'), trigger: 'blur' }
        ],
        totalIssue: [
          { required: true, message: this.$t('计划发放数量') + this.$t('不能为空'), trigger: 'blur' }
        ],
        issuedNum: [
          { required: true, message: this.$t('已发出数量') + this.$t('不能为空'), trigger: 'blur' }
        ],
        receivedNum: [
          { required: true, message: this.$t('已被领取数量') + this.$t('不能为空'), trigger: 'blur' }
        ],
        usedNum: [
          { required: true, message: this.$t('已使用数量') + this.$t('不能为空'), trigger: 'blur' }
        ],
        categoryId: [
          { required: true, message: this.$t('商品分类ID') + this.$t('不能为空'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('状态：1启用 0禁用') + this.$t('不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {},
  created() {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
    'form.couponType'(couponType) {
      if (couponType === 2) {
        this.form.amount = 0
        this.form.isPointExchange = 0
        this.form.needPoints = 0
      } else {
        this.form.discountRate = 0
      }
      if (couponType === 3) {
        this.form.categoryId = 0
      }
    }
  },
  mounted() {
  },
  methods: {
    moment,

    onClose() {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        couponName: null,
        couponType: 1,
        amount: 0,
        discountRate: 0,
        thresholdAmount: 0,
        validStartTime: null,
        validEndTime: null,
        isNewUser: 0,
        isPointExchange: 0,
        needPoints: 0,
        totalIssue: 0,
        issuedNum: 0,
        receivedNum: 0,
        usedNum: 0,
        categoryId: 0,
        status: 0,
        images: null,
        localeFieldMap:{},
        createTime: null
      }

    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCoupon({ 'id': id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },

    /** 提交按钮 */
    submitForm: function() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          const payload = { ...this.form }
          if (payload.couponType === 2) {
            payload.amount = 0
            payload.isPointExchange = 0
            payload.needPoints = 0
          } else {
            payload.discountRate = 0
          }
          if (payload.couponType === 3) {
            payload.categoryId = 0
          }
          let message = ''
          if (payload.id !== undefined && payload.id !== null) {
            message = this.$t('修改成功')
            updateCoupon(payload).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('添加成功')
            addCoupon(payload).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style scoped>
.i18n-ok {
  background-color: #52c41a;
  border-color: #52c41a;
  color: #fff;
}
.i18n-missing {
  background-color: #ff4d4f;
  border-color: #ff4d4f;
  color: #fff;
}
</style>
